// @flow
import {
  SET_PROGRESS,
  SET_MESSAGES,
  SET_MODAL,
  REMOVE_MESSAGES_BY_KEY,
  DEFAULT_GROUP,
  defaultElement
} from './ui.const.js';

import type { InputMessage, InputMessages, Messages } from './ui.types.js';

export function setProgress(progress: boolean, identifier: ?string = null): Action {
  return {
    type: SET_PROGRESS,
    payload: {
      progress,
      identifier
    }
  };
}

export function setMessages(messages: InputMessage | InputMessages | Messages): Action {
  const keyedMessages: Messages = [].concat(messages).map(message => ({
    ...message,
    key:
      Math.random()
        .toString(36)
        .substring(2) + Date.now().toString(36),
    element: message.element || defaultElement,
    group: message.group || DEFAULT_GROUP
  }));

  return {
    type: SET_MESSAGES,
    payload: {
      messages: keyedMessages
    }
  };
}

export function setLoadingMessage(): Action {
  return setMessages({
    type: 'info',
    text: 'Loading ...'
  });
}

export function setModal(modalState: boolean, identifier: ?string = null): Action {
  return {
    type: SET_MODAL,
    payload: {
      modalState,
      identifier
    }
  };
}

export function removeMessageByKey(key: string): Action {
  return {
    type: REMOVE_MESSAGES_BY_KEY,
    payload: {
      key
    }
  };
}
